// extracted by mini-css-extract-plugin
module.exports = {"list":"rdg_639f47bb rdg_119f4c5b rdg_ea6f936f rdg_09d341fe"};